import { DateTime, Duration } from 'luxon';
import { useEffect, useState } from 'react';
const formatSingleNumber = (digit) => (digit.length === 1 ? `0${digit}` : digit);
const getFormattedRemainingTime = (time) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const result = Duration.fromMillis(time)
        .shiftTo('days', 'hours', 'minutes', 'seconds')
        .toObject();
    const isExpired = Number(result.days) + Number(result.hours) + Number(result.minutes) + Number(result.seconds) <=
        0;
    if (isExpired) {
        return {
            days: '00',
            hours: '00',
            minutes: '00',
            seconds: '00',
        };
    }
    return {
        days: (_b = (_a = result === null || result === void 0 ? void 0 : result.days) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '00',
        hours: formatSingleNumber((_d = (_c = result === null || result === void 0 ? void 0 : result.hours) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : '0'),
        minutes: formatSingleNumber((_f = (_e = result === null || result === void 0 ? void 0 : result.minutes) === null || _e === void 0 ? void 0 : _e.toString()) !== null && _f !== void 0 ? _f : '0'),
        seconds: formatSingleNumber((_h = Math.floor((_g = result === null || result === void 0 ? void 0 : result.seconds) !== null && _g !== void 0 ? _g : 0).toString()) !== null && _h !== void 0 ? _h : '0'),
    };
};
export const useCountdown = (endDate) => {
    const zone = 'UTC+2';
    const [remainingTimeInMs, setRemainingTimeInMs] = useState(endDate.diff(DateTime.local({
        zone,
    })));
    useEffect(() => {
        const calculateRemainingTimeInMs = () => {
            const timeLeft = endDate.diff(DateTime.local({
                zone,
            }));
            setRemainingTimeInMs(timeLeft);
        };
        const interval = setInterval(() => calculateRemainingTimeInMs(), 1000);
        return () => clearInterval(interval);
    }, [endDate]);
    return getFormattedRemainingTime(remainingTimeInMs.milliseconds);
};
//# sourceMappingURL=useCountdown.js.map